import { Component, OnInit,ViewChild } from '@angular/core';
import { ProductionHistoryService } from '../../../services-http/production-history/production-history.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment} from '../../../../environments/environment';
import Swal from 'sweetalert2';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { ModalDirective  } from 'ng-uikit-pro-standard';

@Component({
  selector: 'app-admin-cac-cash-in-approval',
  templateUrl: './admin-cac-cash-in-approval.component.html',
  styleUrls: ['./admin-cac-cash-in-approval.component.scss']
})
export class AdminCacCashInApprovalComponent implements OnInit {
  @ViewChild('basicModal') basicModal: ModalDirective;

  CashIn:any=[];
  detail:any =[];
  searchText:any='';
  user = JSON.parse(localStorage.getItem("currentUser"));
  url =environment.url;
  date_from:any;
  date_to:any;
  type:any='list';
  area:any = this.user.area;


  public myDatePickerOptions: IMyOptions = {
    // Your options
  };

  public myDatePickerOptions1: IMyOptions = {
    // Your options
  };

  constructor(
    private productHis: ProductionHistoryService,
    private spinner: NgxSpinnerService
   ) { }


  ngOnInit() {
    this.cash_In_approval(1)
  } 

  cash_In_approval(pageno){
    setTimeout(() => this.spinner.show(), 0);

    let data={
      page:pageno,
      sender_name:this.searchText,
      reference_no:this.searchText==''?'reference_no':this.searchText,
      area: this.area
    }
    this.productHis.cash_In_approval(data).subscribe(res => {
      this.CashIn=res;
      this.spinner.hide();
    },error=>{
      this.spinner.hide();
    });
  }


  approval(cash){
    let data = {
      cashin_id : cash.id,
      user_id : this.user.userId,
      status: 1,
    } 

     Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, proceed!"
        }).then((result) => {
          this.spinner.show()
          
          if (result.value) {
            this.productHis.approve_cashin( data ).subscribe(res => {
              let index=this.CashIn.data.findIndex(x=>x.id==cash.id);
              this.CashIn.data[index].approved = 1;

              // this.cash_In_approval(this.CashIn.current_page);

              this.spinner.hide();

              Swal.fire(
                'Success',
                res['msg'],
                'success'    
              );    

            },error=>{
              this.spinner.hide();
            });

          }
      });  
  } 


  display_cashIn_image(file){
    this.productHis.display_cashIn_image(file).subscribe(res=>{
        window.open(res, '_blank');
    },error=>{
      alert('Something went wrong.');
    });
  }


  async disapprove_cashIn(cash){
    const { value: accept } = await Swal.fire({
      input: 'textarea',
      inputPlaceholder:'Type your message here!',
      confirmButtonText:'Continue <i class="fa fa-arrow-right"></i>',
      inputValidator: (result) => {
        return !result && 'You need to input remarks'
      }
    });
    
    if (accept) {
      this.productHis.disapprove_cashIn({id:cash.id, remarks:accept,loginId: this.user.iloginId }).subscribe(res => {

        let index=this.CashIn.data.findIndex(x=>x.id==cash.id);
        this.CashIn.data[index].approved = 2;

        // this.cash_In_approval(this.CashIn.current_page);

        Swal.fire(
          'Success',
          res['msg'],
          'success'    
        );    
      },error=>{
        Swal.fire(
          'error',
          'Something went wrong!',
          'error'
        );
      });
    }
  }

  print_paid_bill(bill_id){
    this.productHis.print_paid_bill(bill_id).subscribe((res:any) => {
      
      var blob = new Blob([res], {type: 'application/pdf'});
      var downloadURL = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = downloadURL;
      link.download = "paid-bill-statement.pdf";
      link.click();

    },error=>{
      Swal.fire(
        'error',
        'Something went wrong!',
        'error'
      );
    });
  }



  export(){
    this.spinner.show();

    let data={
      posting_type: 0,
      date_from: this.date_from,
      date_to: this.date_to,
      type_or_report: this.type
    }

    this.productHis.cashInReport(data).subscribe((res:any) => {
      this.spinner.hide();

      this.basicModal.hide();
      window.open(res);

    },error=>{
      Swal.fire(
        'error',
        'Something went wrong!',
        'error'
      );
    });
  }

}
